<template lang="html">
  <table class="info-table">
    <tbody>
      <tr
        v-for="header in headers"
        :key="header.text"
      >
        <td class="info-table--header font-weight-bold pr-4">{{header.text}}</td>
        <td class="info-table--value">{{header.morph ? header.morph(value[header.value], header.value, value) : value[header.value]}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'InfoTable',
  props: {
    headers: {
      default: () => []
    },
    value: {
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
